import { checkComboBoxValue, checkComboBoxValueNotEmpty } from '../../helpers/validators';
export const validateСitizenship = ({ value, сitizenshipItems, required, }) => {
    if (required) {
        return checkComboBoxValueNotEmpty({ value }) && checkComboBoxValue({ value, items: сitizenshipItems });
    }
    return value?.code || value?.name ? checkComboBoxValue({ value, items: сitizenshipItems }) : null;
};
